// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z7MZ","colBig":"styles_colBig__2tSvq","colSmall":"styles_colSmall__2HbUU"};